import { pageByCategoryId } from '@/services/news';
import { useRequest } from '@umijs/max';
import { useEffect } from 'react';

export default function useHome() {
  const { data, loading, error, run } = useRequest(pageByCategoryId, {
    manual: true,
  });

  return {
    data: data?.data?.resData,
  };
}
